import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ShellSesion, type ShellMarca } from '@intelishs-group/layout';
import { BackToTop, FileViewer } from '@intelishs-group/ui';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ShellSesion, FileViewer, BackToTop],
  templateUrl: './app.html',
})
export class App {
  /**
   * Identidad visual del shell, y lo UNICO que esta raiz le dice al marco.
   *
   * Antes esto era `LAYOUT_ENV.systemName` en `app.config.ts`, junto a un
   * `apiUrl` y un `logoutUrl` que el shell nuevo no necesita.
   */
  protected readonly marca: ShellMarca = { nombre: 'SINAY - Recursos Humanos' };
}
